
import { supabase } from "@/integrations/supabase/client";
import { Language } from "@/types";

export const fetchLanguages = async (): Promise<Language[]> => {
  const { data, error } = await supabase
    .from('languages')
    .select('*');
  
  if (error) {
    console.error('Error fetching languages:', error);
    throw error;
  }
  
  // Convert from Supabase format to our app format
  return data.map(lang => ({
    code: lang.code,
    name: lang.name,
    id: lang.id,
    is_active: lang.is_active
  }));
};

export const fetchLanguage = async (code: string): Promise<Language> => {
  const { data, error } = await supabase
    .from('languages')
    .select('*')
    .eq('code', code)
    .single();
  
  if (error) {
    console.error('Error fetching language:', error);
    throw error;
  }
  
  // Convert from Supabase format to our app format
  return {
    code: data.code,
    name: data.name,
    id: data.id,
    is_active: data.is_active
  };
};

export const createLanguage = async (code: string, name: string): Promise<Language> => {
  const { data, error } = await supabase
    .from('languages')
    .insert({
      code,
      name,
      is_active: true
    })
    .select()
    .single();
  
  if (error) {
    console.error('Error creating language:', error);
    throw error;
  }
  
  // Convert from Supabase format to our app format
  return {
    code: data.code,
    name: data.name,
    id: data.id,
    is_active: data.is_active
  };
};

export const updateLanguage = async (code: string, name: string): Promise<Language> => {
  const { data, error } = await supabase
    .from('languages')
    .update({ name })
    .eq('code', code)
    .select()
    .single();
  
  if (error) {
    console.error('Error updating language:', error);
    throw error;
  }
  
  // Convert from Supabase format to our app format
  return {
    code: data.code,
    name: data.name,
    id: data.id,
    is_active: data.is_active
  };
};

export const deleteLanguage = async (code: string): Promise<void> => {
  const { error } = await supabase
    .from('languages')
    .delete()
    .eq('code', code);
  
  if (error) {
    console.error('Error deleting language:', error);
    throw error;
  }
};
